import { useEffect } from 'react';

import { selectHoveredRequiredFieldKey } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { selectFocusedRequiredFieldKey } from '../../redux/features/selectors/uiSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { focusRequiredField, scrollRequiredFieldIntoView } from './requiredFieldFocus.ts';

export const useRequiredFieldFocusEffect = () => {
  const focusedRequiredFieldKey = useAppSelector(selectFocusedRequiredFieldKey);
  const hoveredRequiredFieldKey = useAppSelector(selectHoveredRequiredFieldKey);

  useEffect(() => {
    if (!focusedRequiredFieldKey) {
      return;
    }
    focusRequiredField(focusedRequiredFieldKey);
  }, [focusedRequiredFieldKey]);

  useEffect(() => {
    if (!hoveredRequiredFieldKey || hoveredRequiredFieldKey === focusedRequiredFieldKey) {
      return;
    }
    scrollRequiredFieldIntoView(hoveredRequiredFieldKey);
  }, [focusedRequiredFieldKey, hoveredRequiredFieldKey]);
};
